import React, { FunctionComponent, ReactNode, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router';

interface Props {
  tooltip: string;
  children: ReactNode;

  linkTo?: string;
  onClick?: () => void;
}

export const CardAction: FunctionComponent<Props> = ({ tooltip, linkTo, onClick, children }) => {
  const handleClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  const linkProps = linkTo ? { component: Link, to: linkTo } : undefined;
  const eventProps = onClick ? { onClick: handleClick } : undefined;

  return (
    <Tooltip disableInteractive title={tooltip}>
      <IconButton {...linkProps} {...eventProps}>
        {children}
      </IconButton>
    </Tooltip>
  );
};
